import { FC, Fragment } from 'react';
import {
    PerformEnumSelect,
    PerformEnumMultiSelect,
    PerformGreaterLessInput,
    PerformYesNo,
    PerformMultiSelect,
    PerformRefdtoMultiSelect,
    PerformDateRangeFilterSelector,
} from '../perform-indicator/perform-indicator';
import {
    EstimateFilterDto,
    EstimateStatus,
    OpportunityStatus,
} from '@servicetitan/application-data/marketing';
import * as Styles from './segment-parts.module.less';

interface EstimateProps {
    estimate: EstimateFilterDto | undefined;
}

export const Estimate: FC<EstimateProps> = ({ estimate }) => (
    <Fragment>
        <div className={Styles.segmentCardKpiName}>Estimate</div>
        <div>
            <PerformEnumSelect
                name="Estimate Status"
                value={estimate?.status}
                enumType={EstimateStatus}
            />
            <PerformDateRangeFilterSelector
                name="Created On Date"
                valueStatic={estimate?.dateRange}
                valueDynamic={estimate?.dateRangeRelative}
            />
            <PerformGreaterLessInput name="Dollar Value" value={estimate?.total} />
            <PerformRefdtoMultiSelect name="Business Unit" value={estimate?.businessUnits} />
            <PerformEnumMultiSelect
                name="Opportunity Status"
                value={estimate?.opportunityStatuses}
                enumType={OpportunityStatus}
            />
            <PerformYesNo name="Recommended Status" value={estimate?.recommended} />
            <PerformRefdtoMultiSelect name="Technician" value={estimate?.technicians} />
            <PerformMultiSelect name="Tasks" value={estimate?.services} />
            <PerformMultiSelect name="Materials" value={estimate?.materials} />
            <PerformMultiSelect name="Equipment" value={estimate?.equipments} />
            <PerformRefdtoMultiSelect name="Job Type" value={estimate?.jobTypes} />
            <PerformMultiSelect name="Job Tag" value={estimate?.jobTags} />
            <PerformMultiSelect name="Location Zip Code" value={estimate?.zipCodes} />
        </div>
    </Fragment>
);
